import { Component, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { ModalComponent } from '../../modal/modal.component';
import { ModalEditComponent } from '../../modal/modal.edit.component';
import { ModalService } from '../../shared/services/modal.service';
import { HttpResponse } from '@angular/common/http';
import { SubmissionHistoryService } from '../../shared/services/submission-history.service';
import { SubmissionSearchUserInfoObject } from './search-object';

const modalBody = '.modal-body';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: [ './dashboard.component.scss' ]
})
export class DashboardComponent implements OnDestroy {

    @ViewChild('submissionSource')
    readonly modalSubmissionSource: ModalComponent;

    @ViewChild('editSubmissionSource')
    public modalEditSubmissionSource: ModalEditComponent;

    sourceModalUuid: string;
    public  submissionSourceModalTitle: string;
    public  announcementDetailsModalTitle: string;
    public  submissionSourceModalXmlContent: string;
    public  editSubmissionSourceModalXmlContent: string;
    public  xmlWithProperty: string;
    public  submissionResponse: string;
    private submissionSourceModalSubscription: Subscription;
    private userInfoSubscription: Subscription;
    public  confirmationMessage: string;
    public disabled: string;
    public injectProperty: boolean;
    private readonly propertyToInject = '<property name=\"internal-view\" value=\"true\"/>';
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();


    // For a given file size (in bytes), returns a simplified size string to
    // append to the download button.
    // Example: sizeString(2345) -> "2 kB"
    private static sizeString(numBytes: number): string {
        let unit = numBytes;
        if (numBytes < 1000) {
            return Math.floor(unit) + ' B';
        }
        if (numBytes < 1000000) {
            unit /= 1000;
            return Math.floor(unit) + ' kB';
        }
        if (numBytes < 1000000000) {
            unit /= 1000000;
            return Math.floor(unit) + ' MB';
        }
        unit /= 1000000000;
        return Math.floor(unit) + ' GB';
    }

    constructor(readonly submissionHistoryService: SubmissionHistoryService,
                public ref: ChangeDetectorRef,
                readonly modalService: ModalService) {
    }

    public ngOnInit(): void {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => this.userInfo = message);
        this.submissionSourceModalSubscription = this.modalService
            .submissionSourceModalRequests$
            .subscribe(modalRequest => {
                this.displaySubmissionSourceDialog(modalRequest.uuid, modalRequest.hmlId, modalRequest.uploaderFileName, modalRequest.submissionStatus)
            });
    }

    public ngOnDestroy(): void {
        this.submissionSourceModalSubscription.unsubscribe();
    }

    public cleanEdit(): void {
        const menu = document.getElementById('edited-content');
        while (menu.childNodes.length > 1) {
            menu.removeChild(menu.lastChild);
        }
        menu.firstChild.textContent = document.getElementsByClassName('hml-source-text')[0].textContent
    }

    public displaySubmissionSourceDialog(uuid: string, hmlId: string, uploaderFileName: string, submissionStatus: string): void {
        // Step 1: Temporarily clear the title and content areas of the dialog so that a previous
        // sample's contents don't get displayed.
        // TODO: In a future story, replace this with a loading spinner.
        this.submissionSourceModalTitle = 'Loading file...';
        this.submissionSourceModalXmlContent = '\n\n\n\n\n\n\n';
        this.modalSubmissionSource.reprocessButtonTitle('');

        // Step 2: Load the actual content
        let title = 'HML Preview ID ' + hmlId;
        if ((uploaderFileName) != null && (uploaderFileName.trim() !== '')) {
            title += ' / File Name ' + uploaderFileName;
        }

        this.modalSubmissionSource.triggerSpinner(true);
        this.modalSubmissionSource.small(true);
        this.submissionHistoryService
            .getSubmissionText(uuid)
            .then(response =>  {
                if (response) {
                    if (this.userInfo.internalUser) {
                        this.modalSubmissionSource.triggerReprocess(true);
                    }
                    this.modalSubmissionSource.small(false);
                    this.submissionSourceModalTitle = title;
                    this.submissionSourceModalXmlContent = response.body;
                    this.sourceModalUuid = uuid;
                    const contentLength = response.headers.get('X-FILE-SIZE');
                    const downloadSizeMsg = DashboardComponent.sizeString(Number(contentLength));
                    const cbTitle = `Download File (${downloadSizeMsg})`;
                    this.modalSubmissionSource.cancelButtonTitle(cbTitle);
                    this.modalSubmissionSource.okButtonTitle('Close');
                    this.modalSubmissionSource.resubmitButtonTitle('');
                    if (this.userInfo.internalUser) {
                        this.modalSubmissionSource.editButtonTitle('Edit');
                    }
                    this.modalSubmissionSource.triggerSpinner(false);
                }
            });
        $(modalBody).animate({scrollTop: 0}, 500);
        this.modalSubmissionSource.open();
    }

    public downloadFile(uuid: string): void {
        this.modalSubmissionSource.triggerReprocess(false);
        this.submissionHistoryService
            .getSubmissionText(uuid)
            .then((response: HttpResponse<string>) =>  {
                const blob = new Blob([response.body], { type: 'application/xml' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                const filename = response.headers.get('X-NMDP-FILE-NAME');
                console.log('received filename: ' + filename);
                link.download = filename;
                link.click();
            });
    }

    public editFile(): void {
        this.modalSubmissionSource.triggerReprocess(false);
        this.cleanEdit();
        this.modalSubmissionSource.close();
        this.editSubmissionSourceModalXmlContent = this.submissionSourceModalXmlContent;
        this.injectProperty = this.editSubmissionSourceModalXmlContent.includes(this.propertyToInject);
        this.modalEditSubmissionSource.resubmitButtonTitle('Submit');
        $(modalBody).animate({scrollTop: 0}, 500);
        this.modalEditSubmissionSource.open();
    }

    public confirmResubmit(): void {
        this.modalEditSubmissionSource.close();
        this.modalSubmissionSource.editButtonTitle('');
        this.modalSubmissionSource.small(true);
        this.editSubmissionSourceModalXmlContent = document.getElementById('edited-content').innerText
        this.submissionSourceModalTitle = 'Confirm Resubmission';
        this.submissionSourceModalXmlContent = '';
        this.modalSubmissionSource.resubmitButtonTitle('Submit');
        this.modalSubmissionSource.okButtonTitle('Cancel');
        this.modalSubmissionSource.cancelButtonTitle('');
        $(modalBody).animate({scrollTop: 0}, 500);
        this.modalSubmissionSource.open();
    }

    public resubmitFile(resubmissionXml: string): void {
        this.submissionSourceModalXmlContent = 'Submitting....';
        this.modalSubmissionSource.resubmitButtonTitle('');
        this.modalSubmissionSource.okButtonTitle('Close');
        this.submissionHistoryService
            .resubmitSubmission(resubmissionXml)
            .then((response: any) =>  {
                this.modalSubmissionSource.close();
                this.modalSubmissionSource.small(true);
                this.submissionSourceModalTitle = 'Submission Result';
                this.submissionSourceModalXmlContent  = response.message;
                this.modalSubmissionSource.resubmitButtonTitle('');
                $(modalBody).animate({scrollTop: 0}, 500);
                this.modalSubmissionSource.open();
            });
    }

    public confirmReprocess(): void {
        this.modalEditSubmissionSource.close();
        this.modalSubmissionSource.editButtonTitle('');
        this.modalSubmissionSource.small(true);
        this.modalSubmissionSource.triggerReprocess(false);
        this.submissionSourceModalTitle = 'Confirm Reprocessing';
        this.submissionSourceModalXmlContent = '';
        this.modalSubmissionSource.resubmitButtonTitle('');
        this.modalSubmissionSource.reprocessButtonTitle('Reprocess');
        this.modalSubmissionSource.okButtonTitle('Cancel');
        this.modalSubmissionSource.cancelButtonTitle('');
        $(modalBody).animate({scrollTop: 0}, 500);
        this.modalSubmissionSource.open();
    }

    public reprocessFile(uuid: string): void {
        this.submissionSourceModalTitle = 'Reprocessing Submission';
        this.submissionSourceModalXmlContent = '';
        this.modalSubmissionSource.reprocessButtonTitle('');
        this.modalSubmissionSource.small(true);
        this.modalSubmissionSource.triggerReprocess(false);
        this.modalSubmissionSource.editButtonTitle('');
        this.modalSubmissionSource.cancelButtonTitle('');
        this.modalSubmissionSource.triggerSpinner(true);
        this.modalSubmissionSource.resubmitButtonTitle('');
        this.modalSubmissionSource.okButtonTitle('Close');
        this.submissionHistoryService
            .reprocessSubmission(uuid)
            .then((response: any) =>  {
                this.modalSubmissionSource.close();
                this.modalSubmissionSource.triggerSpinner(false);
                this.modalSubmissionSource.small(true);
                this.submissionSourceModalTitle = 'Submission Result';
                this.submissionSourceModalXmlContent  = response.message;
                this.modalSubmissionSource.resubmitButtonTitle('');
                $(modalBody).animate({scrollTop: 0}, 500);
                this.modalSubmissionSource.open();
            });
    }

    addEditProp(injectProperty: boolean) {
        this.injectProperty = injectProperty;
        this.xmlWithProperty = document.getElementById('edited-content').innerText;
        var test = this.xmlWithProperty.indexOf("<hmlid");
        if(this.xmlWithProperty.includes(this.propertyToInject)==false&& this.injectProperty==true){
            this.xmlWithProperty = this.xmlWithProperty.substring(0, test) +
                this.propertyToInject + this.xmlWithProperty.substring(test, this.xmlWithProperty.length);
        }else if(this.injectProperty==false&& this.xmlWithProperty.includes(this.propertyToInject)==true){
            this.xmlWithProperty = this.xmlWithProperty.replace(this.propertyToInject, "")
        }
        $("#edited-content .hml-source-text").text(this.xmlWithProperty);
    }
}
